<template>
  <Transition name="fade-up" appear>
    <component :is="tag" v-bind="$attrs" v-on="$listeners">
      <slot />
    </component>
  </Transition>
</template>

<script>
export default {
  name: 'FadeInUp',
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>
